import { TemplatePage } from './types';

const tutorialsPage: TemplatePage = {
  header: {
    color: '#FAB26A',
    icon: 'images/video-templates/how-to-tutorials.jpg',
    title: 'Video Templates for Tutorials and How-to Videos',
    title_meta:
      '50+ Free and Editable Video Templates for Tutorials and How-to Videos',
    description_meta:
      'Get a set of 50+ customizable video templates to create pro-looking and easy-to-follow video tutorials.',
    description:
      'Share your profound expertise and valuable tips via videos using this collection of customizable video ' +
      'templates. Educate your followers and win their trust sharing video life-hacks, short how-to videos, and ' +
      'tutorials.'
  },
  footer: {
    category: 'Tutorials & How-to',
    description:
      'Wave.video editor comes with a wide range of video templates that you can easily customize to your industry, ' +
      'use case and brand. It doesn’t take a lot of time and effort to come up with attention-grabbing video ' +
      'content. Browse the collection of professionally made video templates, find the ones you like, and adapt ' +
      'them to your needs using powerful editing features.'
  },
  content: [
    {
      type: 'templates',
      title: 'Video Templates for Tutorials and How-to Videos ',
      search: { category: "/Use Cases/How To's & Tutorials" }
    },
    {
      type: 'stocks',
      title: "how to's and tutorials ",
      search: { name: 'tutorial' }
    },
    { type: 'calendar' }
  ]
};

export default tutorialsPage;
